var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
      ],
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: 12,
              expression: "12",
            },
          ],
          staticClass: "flex-row flex-center mt-3",
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("individualEventTab.isAraRelevant")) + ": "),
          ]),
          _c("pui-toggle", {
            attrs: { checked: _vm.currentState.isAssetReliabilityRelevant },
            on: { change: _vm.toggleIsAraRelevant },
            scopedSlots: _vm._u([
              {
                key: "puiToggleLeft",
                fn: function () {
                  return [
                    _c("span", { staticClass: "pl-2" }, [
                      _vm._v(_vm._s(_vm.$t("no"))),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "puiToggleRight",
                fn: function () {
                  return [_vm._v(" " + _vm._s(_vm.$t("yes")) + " ")]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "pui-form-group",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: 12,
              expression: "12",
            },
          ],
          attrs: { label: _vm.$t("individualEventTab.incidentPenaltyType") },
        },
        [
          _c("pui-form-input-field", {
            attrs: {
              value: _vm.currentState.incidentPenaltyName,
              "placeholder-text": _vm.$t("placeholder"),
              "is-disabled": "",
            },
          }),
        ],
        1
      ),
      _c(
        "pui-form-group",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: 12,
              expression: "12",
            },
          ],
          attrs: { label: _vm.$t("individualEventTab.incidentPenaltyValue") },
        },
        [
          _c("pui-form-input-field", {
            attrs: {
              value: _vm.currentState.incidentPenalty?.toString(),
              "is-disabled": _vm.isReadOnly || _vm.isIncidentPenaltyDisabled,
              "is-valid": _vm.isIncidentPenaltyValid,
              type: "number",
            },
            on: {
              input: (value) =>
                (_vm.currentState.incidentPenalty = Number(value)),
            },
          }),
        ],
        1
      ),
      _vm.isParentEvent
        ? _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 12,
                  expression: "12",
                },
              ],
              attrs: {
                label: _vm.$t("individualEventTab.incidentPenaltyThreshold"),
              },
            },
            [
              _c("pui-form-input-field", {
                attrs: {
                  value: _vm.incidentPenaltyThreshold,
                  "is-disabled": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isParentEvent
        ? _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 12,
                  expression: "12",
                },
              ],
              attrs: {
                label: _vm.$t("individualEventTab.mWhLossMWCapacityThreshold"),
              },
            },
            [
              _c("pui-form-input-field", {
                attrs: {
                  value:
                    _vm.currentState.mWhLossMWCapacityThreshold?.toString(),
                  "is-disabled": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("pui-lightbox", {
        ref: _vm.forbiddenChoicePopupRef,
        attrs: {
          "default-header-label": _vm.$t("forbidden"),
          "default-trigger-label": "",
          "show-lightbox-close-icon": false,
          "fit-content": true,
          fullscreen: false,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c("div", { staticClass: "mt-3 mb-3" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("individualEventTab.araRelevantForbidden")
                      ) +
                      " "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "lightbox-footer",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "pui-form-grid-column",
                        rawName: "v-pui-form-grid-column",
                        value: { s: 12, l: 3 },
                        expression: "{ s: 12, l: 3 }",
                      },
                    ],
                  },
                  [
                    _c(
                      "pui-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.closePopup()
                          },
                        },
                      },
                      [_vm._v(" OK ")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }